import MediaLibrary from './container/CommonMediaLibraryContainer';

export default MediaLibrary;
